import { subTopicImages } from "../servicesData";
import ServiceDetailPage from "../ServiceDetailPage";

const BusinessValuationFinancialModelling = () => {
  const serviceData = {
    title: "Business Valuation & Financial Modelling",
    heading: "Business Valuation & Financial Modelling",
    image: subTopicImages["Business Valuation & Financial Modeling"],
    intro:
      "Independent assessment of business value — backed by analysis and professional judgement",
    description: [
      "Valuation is a critical input for transactions, restructuring, regulatory compliance, investment evaluation and shareholder negotiations. We provide independent and well-supported valuation opinions based on globally accepted methodologies and Indian regulatory requirements.",
      "We undertake valuations for acquisitions & investments, joint ventures, shareholder transactions, financial reporting, regulatory and tax purposes, restructuring & reorganisation, and ESOPs & incentive plans.",
    ],
    services: [
      {
        title: "Our Work Typically Includes",
        list: [
          "detailed business understanding",
          "financial forecast review",
          "industry & market benchmarking",
          "DCF & relative valuation analysis",
          "scenario modelling & sensitivity analysis",
          "independent valuation opinion/report",
        ],
        extraInfo:
          "Where required, we also support financial modelling including cash-flow models, deal-impact scenarios and commercial feasibility assessments.",
      },
    ],
    benefitsIntro: "",
    benefits: [],
    research: "",
  };

  return (
    <ServiceDetailPage
      {...serviceData}
      overview={serviceData.description}
      services={serviceData.services}
      benefits={serviceData.benefits}
    />
  );
};

export default BusinessValuationFinancialModelling;
